<template>
	<vxe-modal @show="show" @hide="hide" v-model="modalShow" :title="title" width="1200" height="800" show-footer>
		<template #default>
			<h2 style="margin: 0;">商品ID：{{row.realitemId}}</h2>
			<h2 style="margin: 0;color: #F56C6C;" v-if="specerror || numerror">数据质检:
				<span v-if="specerror">【规格不一致/{{specerror}}】</span>
				<span v-if="numerror">【数量不一致/{{numerror}}】</span>
			</h2>
			<h2 style="margin: 0;color: #67C23A;" v-else>数据质检：合格</h2>
			<h3 style="margin: 0;color: #409EFF;">过检小技巧：规格一致【sku名称中的数字 和 商品规格中的数字 互相包含(去除一些特殊数字)】 数量一致【xxx套装(1套)】【xxx200米(1条)】加上单位否则视为1</h3>
			<vxe-toolbar>
				<template #buttons>
					<vxe-input v-model="keyword" type="search" placeholder="输入关键字" @keyup="inputkeyword"></vxe-input>
					<vxe-button @click="flash" status="primary">刷新</vxe-button>
					<vxe-button @click="exportData" status="success">导出</vxe-button>
					<vxe-button @click="pull" status="danger">拉取线上信息</vxe-button>
					<vxe-button @click="pullgroupcode" status="warning">更新组合编码信息</vxe-button>
				</template>
			</vxe-toolbar>
			<vxe-table :column-config="{resizable: true}" border :footer-method="footerMethod" :loading="loading"
				:data="showData" size="mini" height="550" show-footer :tree-config="{transform: true}"
				ref="goodsonlinedetail">
				<vxe-column type="checkbox" width="50"></vxe-column>
				<vxe-column type="seq" width="50"></vxe-column>
				<vxe-column field="" title="详情" type="expand" width="50">
					<template #content="{ row }">
						<div style="margin: 10px;box-sizing: border-box;" v-if="row.detail.length!=0">
							<el-divider>子商品</el-divider>
							<vxe-table border :data="row.detail" size="mini" show-footer>
								<vxe-column type="seq" width="60"></vxe-column>
								<vxe-column field="groupcode" title="组合编码"></vxe-column>
								<vxe-column field="goodscode" title="商品编码"></vxe-column>
								<vxe-column field="name" title="商品名称"></vxe-column>
								<vxe-column field="model" title="商品规格"></vxe-column>
								<vxe-column field="unit" title="单位"></vxe-column>
								<vxe-column field="nums" title="数量"></vxe-column>
								<vxe-column field="weight" title="重量"></vxe-column>
								<vxe-column field="cost" title="成本"></vxe-column>
							</vxe-table>
						</div>
					</template>
				</vxe-column>
				<vxe-column field="onlinepic" title="图片" width="60">
					<template #default="{ row }">
						<el-image style="width: 30px; height: 30px" :src="row.onlinepic" :preview-src-list="[row.onlinepic]">
						</el-image>
					</template>
				</vxe-column>

				<vxe-column field="skuid" title="SKUID" type="html" width="100"></vxe-column>
				<vxe-column field="goodsname" title="sku名称" type="html" width="180"></vxe-column>
				
				<vxe-column field="goodscode" title="sku编码" type="html" width="150">
					<template #default="{ row }">
						<span v-if="row.check_success == 1" style="color: #67C23A;">{{row.goodscode}}</span>
						<span v-else style="color: #F56C6C;">{{row.goodscode}}</span>
						
					</template>
				</vxe-column>
				
				<vxe-column field="goodsprice" title="原价价格"></vxe-column>
<!-- 				<vxe-column field="goodsprice2" title="原价价格*0.9"></vxe-column> -->
				<vxe-column field="weight" title="重量" sortable></vxe-column>
				<vxe-column field="cost" title="成本" sortable></vxe-column>
				<vxe-column field="profit" title="毛利率(%)" sortable></vxe-column>
				<vxe-column field="check_error" title="质检" width="120" fixed="right" sortable></vxe-column>
			</vxe-table>
		</template>
	</vxe-modal>
</template>
<style>

</style>

<script>
	import XEUtils from 'xe-utils'
	export default {
		name: '',
		props: {
			row: {
				type: Object,
				default: () => {
					return null
				}
			},
			list: {
				type: Object,
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				keyword: '',
				specerror:0,
				numerror:0,
				modalShow: false,
				tableData: [],
				showData: [],
				loading: false,
				title: '详情'
			}
		},
		watch: {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			show() {
				this.init()
			},
			hide() {
				this.tableData = []
				this.showData = []
			},
			flash(){
				this.init()
			},
			pull() {
				this.loading = true
				this.$api.goodsonline.pull({
					itemId: this.row.itemId
				}).then(() => {
					this.init()
					this.loading = false
				}, () => {
					this.loading = false
				})
			},
			pullgroupcode(){
				let data = this.$refs.goodsonlinedetail.getCheckboxRecords()
				if(!data.length){
					this.$message.error('请选择数据')
					return
				}

				let codes = data.map((item)=>{
					return item.goodscode
				})
				if(codes.length > 10){
					this.$message.error('最多不要超过10条')
					return
				}
				this.loading = true
				this.$api.goodsonline.pullgroupcode({
					codes: codes
				}).then(() => {
					this.init()
					this.loading = false
				}, () => {
					this.loading = false
				})
			},
			init() {
				this.loading = true
				this.specerror = 0
				this.numerror = 0
				this.$api.goodsonline.goodsgroupcost(this.row.itemId).then((res) => {
					let groupdata = this.$Lodash.groupBy(res, 'code')
					let tabledata = []

					for (let i in groupdata) {
						let obj = {}
						obj.id = groupdata[i][0].id
						obj.onlinepic = groupdata[i][0].onlinepic
						obj.skuid = groupdata[i][0].skuid
						obj.goodsname = groupdata[i][0].skuname
						obj.goodscode = groupdata[i][0].skucode
						obj.goodsprice = groupdata[i][0].skuprice
						obj.check_success = groupdata[i][0].check_success
						
						// obj.goodsprice2 = groupdata[i][0].skuprice2
						obj.weight = this.$Lodash.sumBy(groupdata[i], item => parseFloat(item.weight) * item.nums)
						obj.weight = obj.weight.toFixed(6)
						obj.cost = this.$Lodash.sumBy(groupdata[i], item => parseFloat(item.cost) * item.nums)
						obj.profit = (obj.goodsprice - obj.cost) / obj.goodsprice * 100
						obj.profit = obj.profit.toFixed(2)
						obj.cost = obj.cost.toFixed(4)
						obj.detail = groupdata[i]
						
						if(groupdata[i].length == 1){
							obj.check_error = groupdata[i][0].check_error
							obj.check_error.forEach((item)=>{
								if(item == '规格不一致'){
									this.specerror++
								}
								if(item == '数量不一致'){
									this.numerror++
								}
							})
							obj.check_error = obj.check_error.join(',')
						}else{
							obj.check_error = ''
							obj.check_success = 1
						}

						tabledata.push(obj)
					}
					this.tableData = tabledata
					this.showData = tabledata
					this.loading = false
				}, () => {
					this.loading = false
				})
			},
			footerMethod({
				data
			}) {

				let l = data.length
				let amountcost = 0
				let amountprofit = 0
				data.forEach((item) => {
					if (parseFloat(item.cost) && parseFloat(item.profit)) {
						amountcost += parseFloat(item.cost)
						amountprofit += parseFloat(item.profit)
					}
				})
				let footer = ['均值', '', '', '', '', '', '', '',  (amountcost / l).toFixed(4), (amountprofit / l).toFixed(2)]
				return [footer]
			},
			exportData() {
				this.$refs.goodsonlinedetail.exportData({
					filename: this.title,
					type: 'xlsx',
					isHeader: true,
					isFooter: true,
					data: this.tableData
				})
			},
			inputkeyword() {
				const keyword = XEUtils.toValueString(this.keyword).trim().toLowerCase()
				if (keyword) {
					const filterRE = new RegExp(keyword, 'gi')
					const searchProps = ['skuid', 'goodsname', 'goodscode']
					const rest = this.tableData.filter(item => searchProps.some(key => XEUtils.toValueString(item[key])
						.toLowerCase().indexOf(keyword) > -1))
					this.showData = rest.map(row => {
						const item = Object.assign({}, row)
						searchProps.forEach(key => {
							item[key] = XEUtils.toValueString(item[key]).replace(filterRE, match =>
								`<span style="color: #000;background-color: #FFFF00;">${match}</span>`)
						})
						return item
					})
				} else {
					this.showData = this.tableData
				}
			}
		},
		components: {

		}
	}
</script>